export const REPORT_VIEW_MODE = {
  ROWS: "rows",
  GROUPED: "grouped",
} as const

export type ReportViewMode =
  (typeof REPORT_VIEW_MODE)[keyof typeof REPORT_VIEW_MODE]

export const DEFAULT_REPORT_VIEW_MODE = REPORT_VIEW_MODE.ROWS

export function isReportViewMode(
  value: string | null | undefined,
): value is ReportViewMode {
  return value === REPORT_VIEW_MODE.ROWS || value === REPORT_VIEW_MODE.GROUPED
}
